<template >


	<section>
	     <!-- Content Header (Page header) -->
	     <section class="content-header">
	        <h1>
	           CREAR PAPELETA
	           <small>Percy</small>
	        </h1>
	        <ol class="breadcrumb">
	           <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
	           <li class="active">Ver Papeleta</li>
	        </ol>
	     </section>
	     <!-- Main content -->
	     <section class="content">
	        <div class="row">
	        <!-- left column -->
	          <div class="col-md-12">
	             <!-- general form elements -->
	             <div class="box box-primary">

	             	<div class="box-header with-border">
		               <h3 class="box-title">Detalle:</h3>
		            </div>

	                <!-- /.box-header -->
	                <!-- form start -->
            		<div class="row">

                      	<div class="col-md-12">
													<form class="" @submit.prevent="submitPapeleta">



                        	<div class="col-md-12">
	                           <div class="form-group">
	                              <label>TIPO DE PAPELETA</label>


																<select class="form-control" v-model="papeleta.tipopapeleta">
																		<option v-for="tipo in tipos_papeleta" :value="tipo.tipopapeleta"> {{tipo.descripcion	}}</option>
																</select>


	                           </div>
	                        </div>

	                        <div class="col-md-12">
	                           <div class="form-group">
	                              <label>FEC. INICIO.</label>
	                              <input type="text"  class="form-control"  id="fi"  >
	                           </div>
	                        </div>


	                        <div class="col-md-12">
	                           <div class="form-group">
	                              <label>FEC. TERMINO</label>
	                              <input type="text"  class="form-control"   id="ft"  >
	                           </div>
	                        </div>


	                        <div class="col-md-12">
	                           <div class="form-group">
	                              <label>MOTIVO</label>

																<textarea class="form-control"  v-model="papeleta.observacion"></textarea>
	                           </div>
	                        </div>

													<!--
	                        <div class="col-md-12">
	                           <div class="form-group">
	                              <label>FEC. REGISTRO</label>
	                              <input type="text"  class="form-control"  placeholder="Company"  v-model="papeleta.n5">
	                           </div>
	                        </div>
												-->


	                        <div class="col-md-12">

	                        	<div class="form-group">

	                        		<input type="hidden" name="id">
	                        		<button class="btn btn-light" type="submit">Guardar</button>
	                        	</div>
	                        </div>

	                    </form>
	                         <!--

	                          <button class="btn btn-light">
	                           <i class="fa fa-trash"> Eliminar</i>
	                         </button>
	                      -->

                      	</div>
            		</div>


	                <br>



	             </div>
	             <!-- /.box -->
	          </div>

	      </div>
     </section>
  </section>


</template>

<script>

import config from './../../config';


export default {

  name  :  'PapeletasCrear',
  data(){
    return {

			papeleta : {
				tipopapeleta : 'LIMABGT 000000000013',
				fechaInicio  : null,
				fechaFin : null,
				observacion  : null,
				fecRegistro : null,
				dni : '25756304',
				userid : '100255',
			}
    }
  },
	computed : {
		tipos_papeleta(){
			return this.$store.getters.tipos_papeleta
		}
	},
	mounted(){
		this.$store.dispatch('loadTipoPapeletas');

		//cargamos el timepicker

		$('#fi').datetimepicker({format:'Y-d-m H:i:s'});
		$('#ft').datetimepicker({format:'Y-d-m H:i:s'});
	},
	methods : {

		submitPapeleta(){
			console.log('Enviamos',this.papeleta);

			console.log('xddd');
			/*
			let fechaInicioConvert  = $('#fi').val().split('-')
			this.papeleta.fechaInicio = fechaInicioConvert[0]+'-'+fechaInicioConvert[2]+'-'+fechaInicioConvert[1] ;


			let fechaInicioConvertF  = $('#ft').val().split('-')
			this.papeleta.fechaFin = fechaInicioConvertF[0]+'-'+fechaInicioConvertF[2]+'-'+fechaInicioConvertF[1] ;
*/
			this.papeleta.observaciones  = this.papeleta.observacion

			//xd
			this.papeleta.fechaInicio = $('#fi').val();
			this.papeleta.FechaFin = $('#ft').val();


			this.papeleta.FechaIni = this.papeleta.fechaInicio


			console.log('eNVIAMOS', this.papeleta);
			swal("Procesando...")
			axioss.get(config.serverURI +'aplicaciones/insertp',{params:this.papeleta})
				.then((data)=>{
					console.log('Resultados al editar' ,data);
					swal("Proceso completado","","success")
					this.$router.push('/papeletas_salida')
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/views/PapeletasCrear.vue